// Presenter Archetype API client: direct PDF download for the open
// quiz result/action-plan. Public tool, no auth required. See
// playbookApi.js for the separate, email-gated Presenter Playbook
// guide request. PostHog/GA capture() calls live here so every real
// network attempt fires exactly once, success or failure.

import { capture } from "@/lib/analytics";

const BASE = process.env.REACT_APP_BACKEND_URL;

const paFetch = (path, options = {}) => fetch(`${BASE}/api${path}`, options);

export const downloadReportPdf = async ({ language, answers }) => {
  try {
    const res = await paFetch("/presenter-archetype/report/pdf", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ language, answers }),
    });
    if (!res.ok) {
      capture("presenter_archetype_pdf_download_failed", { language, status: res.status });
      const err = new Error(`pdf_failed_${res.status}`);
      err.status = res.status;
      throw err;
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `InterAct_Presenter_Archetype_${language}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    capture("presenter_archetype_pdf_downloaded", { language });
  } catch (err) {
    if (!err.status) capture("presenter_archetype_pdf_download_failed", { language, status: "network" });
    throw err;
  }
};
